var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/UnfoldMore.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnfoldMore = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M15.7175 15.8907L19.5975 12.0007L15.7075 8.1107C15.3175 7.7207 15.3175 7.0907 15.7075 6.7007C16.0975 6.3107 16.7275 6.3107 17.1175 6.7007L21.7075 11.2907C22.0975 11.6807 22.0975 12.3107 21.7075 12.7007L17.1175 17.2907C16.7275 17.6807 16.0975 17.6807 15.7075 17.2907C15.3275 16.9107 15.3275 16.2707 15.7175 15.8907Z",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.28006 15.8907L4.40006 12.0007L8.29006 8.1107C8.68006 7.7207 8.68006 7.0907 8.29006 6.7007C7.90006 6.3107 7.27006 6.3107 6.88006 6.7007L2.29006 11.2907C1.90006 11.6807 1.90006 12.3107 2.29006 12.7007L6.88006 17.2907C7.27006 17.6807 7.90006 17.6807 8.29006 17.2907C8.67006 16.9107 8.67006 16.2707 8.28006 15.8907Z",
    fill: color
  })]
});